export { Footer } from "./Footer";
export { Footer as default } from "./Footer";
